import type { AvatarConfig } from './avatar-catalog'
import { avatarPieceColor } from './avatar-custom'

export function AvatarAccessories({ config: c }: { config: AvatarConfig }) {
  return (
    <>
      {c.earrings === 'stud' && (
        <g
          fill={avatarPieceColor(c, 'earrings', '#EFC35D')}
          stroke="#FFEDAD"
          strokeWidth="1.5"
        >
          <circle cx="62" cy="145" r="4" />
          <circle cx="178" cy="145" r="4" />
        </g>
      )}
      {c.earrings === 'hoop' && (
        <g
          fill="none"
          stroke={avatarPieceColor(c, 'earrings', '#EFC35D')}
          strokeWidth="4"
        >
          <ellipse cx="60" cy="151" rx="7" ry="11" />
          <ellipse cx="180" cy="151" rx="7" ry="11" />
        </g>
      )}
      {c.accessory !== 'none' && (
        <g
          stroke={c.accessoryColor}
          strokeWidth="5"
          fill={c.accessory === 'sunglasses' ? '#303F42' : 'none'}
        >
          {c.accessory === 'round-glasses' ? (
            <>
              <circle cx="88" cy="126" r="24" />
              <circle cx="152" cy="126" r="24" />
            </>
          ) : (
            <>
              <rect x="64" y="106" width="49" height="37" rx="11" />
              <rect x="127" y="106" width="49" height="37" rx="11" />
            </>
          )}
          <path d="M112 122q8-6 16 0m-65-5-7-3m121 3 7-3" fill="none" />
          {c.accessory === 'sunglasses' && (
            <path
              d="m76 117 11 14m-2-16 6 7m48-5 11 14"
              stroke="#FFF"
              opacity=".2"
              strokeWidth="4"
            />
          )}
        </g>
      )}
      <g fill={c.headwearColor}>
        {c.headwear === 'cap' && (
          <>
            <path d="M58 83Q52 29 118 28Q179 26 182 83Z" />
            <path d="M54 80q59-19 131 0l13 14q-79-12-148 4Z" />
            <path d="M115 34v37" stroke="#FFF" strokeOpacity=".2" strokeWidth="3" />
            <rect x="103" y="48" width="28" height="18" rx="8" fill="#FFFAEC" />
            <path
              d="m111 57 5 4 9-10"
              fill="none"
              stroke={c.headwearColor}
              strokeWidth="3"
              strokeLinecap="round"
            />
          </>
        )}
        {c.headwear === 'beanie' && (
          <>
            <path d="M56 80Q55 21 120 24Q186 24 184 80Z" />
            <circle cx="120" cy="25" r="13" />
            <rect x="53" y="72" width="134" height="25" rx="10" />
            <path
              d="M69 79v11m17-11v11m17-11v11m17-11v11m17-11v11m17-11v11m17-11v11"
              stroke="#FFF"
              strokeOpacity=".3"
              strokeWidth="3"
            />
          </>
        )}
        {c.headwear === 'headband' && (
          <>
            <path d="M62 90Q121 49 180 90l-3 14Q119 65 65 104Z" />
            <path d="M167 85q-4-32 12-23l4 18q29-19 27-3-6 17-28 11Z" />
          </>
        )}
        {c.headwear === 'crown' && (
          <>
            <path d="m77 68-6-39 27 15 22-29 22 29 27-15-6 39Z" fill="#EDBD4E" />
            <rect x="76" y="62" width="89" height="14" rx="5" fill="#F7D775" />
            <path d="m120 35 8 12-8 12-8-12Z" fill={c.headwearColor} />
          </>
        )}
        {c.headwear === 'hijab' && (
          <>
            <path
              d="M49 124Q43 29 120 28Q197 29 191 124L204 213Q168 236 121 224Q73 236 36 213ZM72 111v34q0 44 48 49 48-5 48-49v-34q-24-16-48-45-24 29-48 45Z"
              fillRule="evenodd"
            />
            <path
              d="M77 183q22 38 90 41M64 187q7 25 24 40"
              fill="none"
              stroke="#13261D"
              strokeOpacity=".13"
              strokeWidth="5"
              strokeLinecap="round"
            />
          </>
        )}
      </g>
    </>
  )
}
